import { action } from 'satcheljs';
import { CalendarEventKey } from 'mini-calendar-event-types';
import { OwaDate } from 'owa-datetime';
import { ScrollDirectionType } from 'mini-infinite-scroll';

/**
 * Action to notify to trigger loading of agenda view.
 */
export const loadAgendaView = action(
    'loadAgendaView',
    (
        pivotDate?: OwaDate,
        scrollDirection?: ScrollDirectionType,
        eventsAddedOrRemoved?: CalendarEventKey[]
    ) => ({
        pivotDate,
        scrollDirection,
        eventsAddedOrRemoved,
    })
);

/**
 * This action is fired when agenda view's top date is changed due to scroll.
 * @param newDate The date which is at the top in agenda view.
 */
export const onAgendaViewDateChanged = action(
    'ON_AGENDA_VIEW_DATE_CHANGED',
    (newDate: OwaDate) => ({ newDate })
);

/**
 * This action is fired when agenda view is scrolled.
 */
export const onAgendaViewScroll = action('ON_AGENDA_VIEW_SCROLL');

/**
 * This action is fired when agenda view is scrolled to either top end or bottom end.
 * @param scrollDirection The direction where scroll has happened(up or down).
 */
export const onAgendaViewScrollReachEnd = action(
    'ON_AGENDA_VIEW_SCROLL_REACH_END',
    (scrollDirection: ScrollDirectionType) => ({ scrollDirection })
);

/**
 * This action is fired when agenda view scroll ends.
 */
export const onAgendaViewScrollEnd = action('ON_AGENDA_VIEW_SCROLL_END');

/**
 * This action is fired when loading events has started or completed
 */
export const onAgendaViewLoadingStatusChanged = action(
    'ON_AV_LOAD_IN_PROGRESS',
    (isLoading: boolean) => ({ isLoading })
);

/**
 * Action to reset the agenda view store.
 */
export const resetAgendaStore = action('resetAgendaStore');
